module.exports = __webpack_public_path__ + "img/background-7.3924af8d.jpg";